// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__1ITrf","file":"styles_file__3o9fS"};